module.exports = __webpack_public_path__ + "img/logout-warning-icon.400888e4.svg";